/**
 * Information Intelligence — one sidebar item, four tabs.
 *
 * Feedback, Coach Feedback, Service Ratings and Member Polls each shipped as
 * their own sidebar item. They read four different data sets, but to a club
 * they are one thing: what members think. They now share one nav item and a
 * tab bar.
 *
 * Each tab keeps its old route, so bookmarks and links in emails still open
 * the right screen. Its own module so both sidebars and the layout can import
 * it without pulling in MUI or the router.
 */
export const INTELLIGENCE_TABS = [
  { key: "Feedback", path: "feedback" },
  { key: "Coach Feedback", path: "coach-feedback" },
  { key: "Service Ratings", path: "service-feedback" },
  { key: "Member Polls", path: "polls" },
] as const;

export const INTELLIGENCE_PATHS: string[] = INTELLIGENCE_TABS.map((tab) => tab.path);

/** Route the sidebar item links to. Mobile builds it from the item key. */
export const INTELLIGENCE_HOME = "information-intelligence";
